import { PropsWithChildren } from "react";

export const Page = ({children}: PropsWithChildren) => {
  return (
    <main className="flex flex-col items-center justify-center h-screen">
      {children}
    </main>
  );
}